import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { GET_COURSE_TAGS_BATCH } from '../queries/courseTags';

const courseIdToBlockPrefix = (courseId) => {
  if (!courseId || !courseId.startsWith('course-v1:')) return null;
  return `block-v1:${courseId.slice('course-v1:'.length)}`;
};

export const useCourseTagsBatch = (courseIds) => {
  const validPrefixes = useMemo(
    () => (courseIds || [])
      .map(courseIdToBlockPrefix)
      .filter(Boolean),
    [courseIds],
  );

  const where = useMemo(() => ({
    _or: validPrefixes.map((prefix) => ({
      objectId: { _like: `${prefix}%` },
    })),
  }), [validPrefixes]);

  const { data, loading, error } = useQuery(GET_COURSE_TAGS_BATCH, {
    variables: { where },
    skip: validPrefixes.length === 0,
  });

  const tagsByCourseId = useMemo(() => {
    const result = {};
    if (!data?.oelTaggingObjecttag) return result;

    const pairs = (courseIds || [])
      .map((id) => ({ id, prefix: courseIdToBlockPrefix(id) }))
      .filter((p) => p.prefix);

    data.oelTaggingObjecttag.forEach((tag) => {
      if (!tag?.objectId || !tag?.value) return;
      const match = pairs.find((p) => tag.objectId.startsWith(p.prefix));
      if (!match) return;
      if (!result[match.id]) result[match.id] = new Set();
      result[match.id].add(tag.value);
    });

    Object.keys(result).forEach((id) => {
      result[id] = Array.from(result[id]);
    });

    return result;
  }, [data, courseIds]);

  return { tagsByCourseId, loading, error };
};
